__turbopack_context__.v({
  "className": "open_sans_b8a43e53-module__hypcMa__className",
  "variable": "open_sans_b8a43e53-module__hypcMa__variable",
});
